import { render, staticRenderFns } from "./PageToGWatchGov.vue?vue&type=template&id=ec543874&scoped=true&"
import script from "./PageToGWatchGov.vue?vue&type=script&lang=js&"
export * from "./PageToGWatchGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec543874",
  null
  
)

export default component.exports